import { forwardRef } from "react";
import type { HTMLStyledProps } from "@repo/styled-system/jsx";
import type { ButtonVariantProps } from "@repo/styled-system/recipes";
import { Button, type ButtonProps } from "../button/button";

export interface IconButtonProps
  extends ButtonProps, ButtonVariantProps, HTMLStyledProps<"button"> {}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(props, ref) {
    return <Button px="0" py="0" ref={ref} {...props} />;
  },
);
